import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../components/button'
import CustomModal from '../../../components/CustomModal'
import Input from '../../../components/input'
import Select from '../../../components/Select'
import { fetchPermissionDropdown } from '../../../store/Slices/PermissionSlice'
import { createUser, fetchUsersData } from '../../../store/Slices/UserSlice'
import { validationSchema } from '../../../utils/Schema'
import { errorNotify, successNotify } from '../../../utils/toast'
import FileUpload from '../../../components/FileUpload'

const AddUser = ({ show, onHide, onSuccess, currentPage, limit }) => {
    const dispatch = useDispatch();
    const { userRoles, userRoleLoading, createLoading } = useSelector((state) => state.users);
    const { permissionDropdown, permissionLoading } = useSelector((state) => state.permissions);

    const [uploadedFiles, setUploadedFiles] = useState([]);


    useEffect(() => {
        if (show) {
            // dispatch(fetchUserRoleDropdown());
            dispatch(fetchPermissionDropdown());
        }
    }, [show]);

    const initialValues = {
        name: '',
        email: '',
        role_id: 0,
        group_permissions_id: '',
        image: []
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const userData = {
                name: values.name,
                email: values.email,
                role_id: 0,
                group_permissions_id: values.group_permissions_id,
                image: uploadedFiles[0]?.fileName || ''
            };

            await dispatch(createUser(userData)).unwrap();
            successNotify('User created successfully');
            resetForm();
            setUploadedFiles([]);
            onHide();

            dispatch(fetchUsersData({
                page: currentPage,
                limit: limit
            }))
            if (onSuccess) onSuccess();
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <CustomModal heading="Add User" size="lg" show={show} handleClose={onHide}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                        <Form>
                            <div className='add_user_modal'>
                                <h5>User Information</h5>

                                <div>
                                    <Input
                                        label="Name"
                                        placeholder="Enter Full Name"
                                        type="text"
                                        name="name"
                                        value={values.name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.name}
                                        touched={touched.name}
                                    />
                                    <Input
                                        label="Email Address"
                                        placeholder="Enter Email Address"
                                        type="email"
                                        name="email"
                                        value={values.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.email}
                                        touched={touched.email}
                                    />

                                    <Input
                                        label="Default Password"
                                        placeholder=""
                                        type="password"
                                        name="password"
                                        value={"Name123!"}
                                        disabled={true}
                                    />

                                    <hr />
                                </div>

                                <h5>User Role and Permissions</h5>

                                <div>
                                    {/* <Select
                                        label="User Role"
                                        placeholder="Select User Role"
                                        options={userRoles}
                                        loading={userRoleLoading}
                                        name="role_id"
                                        value={userRoles.find(role => role.value === values.role_id)}
                                        onChange={(selectedOption) => setFieldValue('role_id', selectedOption?.value || '')}
                                        onBlur={handleBlur}
                                        error={errors.role_id}
                                        touched={touched.role_id}
                                    /> */}
                                    <Select
                                        label="Permission Group"
                                        placeholder="Select Permission Group"
                                        options={permissionDropdown}
                                        loading={permissionLoading}
                                        name="group_permissions_id"
                                        value={permissionDropdown.find(permission => permission.value === values.group_permissions_id)}
                                        onChange={(selectedOption) => setFieldValue('group_permissions_id', selectedOption?.value || '')}
                                        onBlur={handleBlur}
                                        error={errors.group_permissions_id}
                                        touched={touched.group_permissions_id}
                                    />
                                </div>

                                <div className='photo_document_section'>
                                    <FileUpload
                                        destination="add-user"
                                        files={uploadedFiles}
                                        setFiles={setUploadedFiles}
                                        maxFileSize={10}
                                        disabled={uploadedFiles.length >= 1}
                                    />
                                </div>

                                <div style={{ marginTop: "40px" }}>
                                    <Button
                                        cancelBtn={onHide}
                                        submitBtn={() => { }}
                                        loading={createLoading || isSubmitting}
                                        disabled={createLoading || isSubmitting}
                                        submitText="Save"
                                        type="submit"
                                    />
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </CustomModal>
        </div>
    )
}

export default AddUser